import React from 'react';

import SimpleSearchInput from '@common/react/components/Forms/SimpleSearchInput/SimpleSearchInput';
import AddChatPopup from '@common/react/components/Chat/AddChatPopup';
import Button from '@common/react/components/Forms/Button';
import ArchiveButton from '@common/react/components/UI/ArchiveButton';

export enum ChatsListHeaderComponents {
	Search,
	AddChat,
	Archive,
	Online,
	AllChats
}

export type ChatListHeaderSettingsType = Array<ChatsListHeaderComponents | 
	(({user, selectChat, handleChange, filters, pageSettings}) => React.ReactNode)>;

export const ChatsListHeaderDictionary = {
	[ChatsListHeaderComponents.Search]: ({handleChange}) =>
		<SimpleSearchInput
			onSubmit={handleChange}
			name="text"
			withoutForm
		/>,
	[ChatsListHeaderComponents.AddChat]: ({user, selectChat}) =>
		<AddChatPopup
			user={user}
			onSave={selectChat}
			render={show => <button className="btn btn-primary" onClick={show} title="Add Chat">
				<i className="fa fa-plus"/>
			</button>}
			type="userChatViewList"
		/>,
	[ChatsListHeaderComponents.AllChats]: ({handleChange, user, filters}) =>
		<Button
			className="btn btn-primary load-chats-btn icon-btn"
			title={`Load ${filters.loadAllChats ? 'only my chats' : 'all company chats'}`}
			onClick={() => handleChange({loadAllChats: !filters.loadAllChats, chatId: null })}
		>
			<i className={`fa fa-comments${filters.loadAllChats ? '' : '-o'}`} aria-hidden="true"/>
		</Button>,
	[ChatsListHeaderComponents.Archive]: ({filters, handleChange, selectChat, pageSettings}) =>
		<ArchiveButton filters={filters} handleChange={handleChange} selectChat={selectChat} pageSettings={pageSettings}/>,
	[ChatsListHeaderComponents.Online]: ({filters, handleChange}) =>
		<Button
			className="btn btn-primary load-chats-btn icon-btn"
			title={filters.online ? 'Online' : 'Offline'}
			onClick={() => handleChange({online: !filters.online})}
		>
			<i className={`fa fa-${filters.online ? 'user' : 'user-o'}`} aria-hidden="true"/>
		</Button>,
};